/* eslint-disable
    no-cond-assign,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import {debounce} from 'ts-debounce';
import UserConstants from 'constants/UserConstants';

const STATUS_SHARED_CLASS = 'fa';
const STATUS_ERROR_CLASS = 'fa-times u-danger-color';
const STATUS_SUCCESS_CLASS = 'fa-check u-success-color';
const FIELDS_TO_TRIM = ['username', 'email', 'name'];

class GettingStartedView extends Backbone.View {
  static initClass() {
    this.prototype.events = {
      'change select[name="affiliation"]': 'toggleFields',
      'input input': 'delayedAuthenticateField',
      submit: 'disableSubmit',

      // We can't just do this on 'change input', since that gets called even before any user interaction.
      'blur input': 'handleBlur',
      'blur select': 'handleBlur',
      'change select': 'handleBlur',
    };
  }

  initialize() {
    this.debouncedAuthenticateField = debounce(this.authenticateField, 500);
  }

  getType() {
    return this.$('select[name="affiliation"]').val();
  }

  affiliationChangeHandler(type) {
    this.$('.info-col .info').addClass('hidden');
    switch (type) {
      case UserConstants.PROCLAIMED_ACADEMIC:
        this.$('.info-col .academic-info').removeClass('hidden');
        break;
      case UserConstants.PROCLAIMED_COMMERCIAL:
        this.$('.info-col .commercial-info').removeClass('hidden');
        break;
      case UserConstants.PROCLAIMED_NONPROFIT:
        this.$('.info-col .nonprofit-info').removeClass('hidden');
        break;
      default:
        this.$('.info-col .general-info').removeClass('hidden');
    }
  }

  disableSubmit(e) {
    this.$('button[type="submit"]').attr('disabled', true).addClass('disabled');
  }

  delayedAuthenticateField(e) {
    // We update the status when the user is typing in the field AND the status is already showing. The
    // 500ms debounce just feels more natural.
    const field = e.target.id;
    const $statusField = $(`#${field}`).prevAll('.fieldStatus').find('.fieldStatus-icon');
    if ($statusField.hasClass('hidden')) {
      return;
    }
    $statusField
      .removeClass(STATUS_SHARED_CLASS)
      .removeClass(STATUS_ERROR_CLASS)
      .removeClass(STATUS_SUCCESS_CLASS)
      .addClass('spinner');
    this.debouncedAuthenticateField(e);
  }

  handleBlur(e) {
    const field = e.target.id;
    if (Array.from(FIELDS_TO_TRIM).includes(field)) {
      e.currentTarget.value = e.currentTarget.value.trim();
    }

    if (field === 'username' && e.currentTarget.value.length === 0) {
      // If the user clicks on an FAQ question before they type anything, we don't want to show
      // the error notification. In the worst case, the user will skip the username field and fill in
      // everything else, and get the error notification after clicking Create Account (but this seems
      // extremely unlikely).
      return;
    }

    this.authenticateField(e);
  }

  authenticateField(e) {
    const field = e.target.id;
    this.authenticateForm().done((errors) => {
      const $statusField = $(`#${field}`).prevAll('.fieldStatus').find('.fieldStatus-icon');
      const $errorField = $(`#${field} ~ .legacy-field-error`);
      const isError = errors[field] != null;
      $errorField.text(isError ? errors[field][0] : '').toggleClass('hidden', !isError);
      $statusField
        .addClass(STATUS_SHARED_CLASS)
        .toggleClass(STATUS_ERROR_CLASS, isError)
        .toggleClass(STATUS_SUCCESS_CLASS, !isError)
        .removeClass('hidden spinner');
    });
  }

  authenticateForm() {
    let left;
    const formData = new FormData();
    this.$('input, select').each((i, field) => {
      let value = $(field).val();
      if (Array.from(FIELDS_TO_TRIM).includes(field.id)) {
        value = value.trim();
      }
      formData.append($(field).attr('name'), value);
    });
    return $.ajax({
      url: (left = this.$('form').data('validate-url')) != null ? left : '/1/api/auth/validate-signup',
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST',
    });
  }

  toggleFields(e) {
    const type = this.getType();
    const isAcademic = type === UserConstants.PROCLAIMED_ACADEMIC;
    const isCommercial = type !== '' && !isAcademic;
    this.$('.js-academic-email-description').toggleClass('hidden', !isAcademic);
    this.$('.academic-fields').toggleClass('hidden', !isAcademic);
    this.$('.commercial-fields').toggleClass('hidden', !isCommercial);
    if (typeof this.affiliationChangeHandler === 'function') {
      this.affiliationChangeHandler(type);
    }
  }

  render() {
    this.toggleFields();
    return this;
  }
}
GettingStartedView.initClass();

export default GettingStartedView;
